module.exports = __webpack_public_path__ + "img/flexible-use-of-funds.f1cbd65.png";